import React, { useState, useEffect } from "react";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import Maincomponent from "../../Components/Maincomponent/Maincomponent";
import Transition from "../../Helper/Transitionroute";
import { Input } from "antd";
import Select from "react-select";
import { Modal } from "antd";
import { Button } from "react-bootstrap";
import Standardoptions from "../../Options/Standardoptions";
import Apifetch from "../../Helper/Apifetch";
import Apiput from "../../Helper/Apiput";

export default function Section_update() {
  const navigate = useNavigate();
  const { id } = useParams();
  const standard_options = Standardoptions();
  const [data, setData] = useState([]);
  const [standard, setstandard] = useState(null);
  const [res, setres] = useState([]);
  const [groupoptions, setgroupoptions] = useState([]);
  const [description, setdescription] = useState("");
  const [group, setgroup] = useState([
    {
      section: "",
      max_students: "",
      group: "",
      description: "",
    },
  ]);
  const [open1, setopen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  let dollarIndianLocale = Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
  });
  const handleFormChange = (index, event) => {
    let data = [...group];
    data[index][event.target.name] = event.target.value;
    setgroup(data);
  };
  const removeFields = (index) => {
    let data = [...group];
    data.splice(index, 1);
    setgroup(data);
  };
  const addFields = () => {
    let newfield = { group: "", max_students: "", description: "" };

    setgroup([...group, newfield]);
  };
  async function postData(event) {
    event.preventDefault();

    try {
      const formdata = {
        standard_name: standard.value,
        description: description,
        section: group,
      };
      const res = await Apiput(`section/${id}/`, formdata);

      navigate("/view_section");
    } catch (error) {
      console.error(error);
      // Handle error here
    }
  }
  async function fetchsectionData(val) {
    try {
      // const response = await axios.get(apiurl + `course/?course_name=${val}`);
      Apifetch(`course/?course_name=${val}`, setres).then((res) => {
        console.log(res.data);
        const convertedarray = res.data[0].group.map((item, index) => ({
          value: item.group,
          label: item.group,
        }));

        setgroupoptions(convertedarray);
      });
    } catch (error) {
      alert(error.message);
    }
  }
  useEffect(() => {
    Apifetch(`section/${id}/`, setData).then((res) => {
      console.log(res.data);
      setstandard({
        label: res.data.standard_name,
        value: res.data.standard_name,
      });
      setdescription(res.data.description);
      setgroup(res.data.section);
      if (
        (res.data.standard_name == "XII") |
        (res.data.standard_name == "XI")
      ) {
        fetchsectionData(res.data.standard_name);
      }
    });
  }, []);
  return (
    <Maincomponent>
      <div className="child-main">
        <div className="child-head">SECTION UPDATE</div>
        <br />
        <div className="childip-main">
          <div className="child-ip-container">
            <div className="childip">
              <div className="grid-item">Standard</div>
              <div className="grid-item">
                <Select
                  value={standard}
                  options={standard_options}
                  disabled
                  onChange={(value) => {
                    setstandard(value);
                    if ((value.value == "XII") | (value.value == "XI")) {
                      fetchsectionData(value.value);
                    }
                  }}
                  placeholder="Select Standard"
                />
              </div>
              <div className="grid-item">Section</div>
              <div className="grid-item">
                <Input
                  type="text"
                  disabled
                  value={group && group.length}
                  className="textipbill"
                  style={{ width: "85%" }}
                />
                &nbsp;
                <Button
                  size="sm"
                  variant="warning"
                  onClick={() => {
                    setopen1(true);
                  }}
                >
                  +
                </Button>
              </div>
            </div>
            <br />
            <div
              style={{
                width: "90%",
                display: "flex",
                justifyContent: "flex-end",
                // backgroundColor: "red",
              }}
            >
              <Button onClick={postData} size="sm">
                Update
              </Button>
            </div>
          </div>
        </div>
        <Modal
          // title="Group"
          // centered
          open={open1}
          styles={{
            content: { backgroundColor: "white" }, // turns the Modal red
          }}
          onOk={() => setopen1(false)}
          onCancel={() => setopen1(false)}
          width={1200}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <Button size="sm" onClick={addFields}>
                Add
              </Button>{" "}
              &nbsp;
              {/* <CancelBtn /> */}
              <OkBtn size="sm" />
            </>
          )}
        >
          <h5>Section</h5>
          <hr></hr>
          <table>
            <tr style={{ padding: 2 }}>
              {/* <th> Sno</th> */}
              <th>Section</th>
              {standard &&
              (standard.value == "XI") | (standard.value == "XII") ? (
                <th>Group</th>
              ) : null}
              <th>Max Students</th>

              <th>Description</th>

              <th></th>
            </tr>

            {group &&
              group.map((input, index) => {
                return (
                  <>
                    <tr>
                      {/* <th>{index + 1}</th> */}
                      <th>
                        {" "}
                        <Input
                          name="section"
                          className="textipbill"
                          style={{
                            width: "150px",
                            border: "0.5px solid gray",
                            color: "black",
                          }}
                          placeholder="Section"
                          onChange={(event) => handleFormChange(index, event)}
                          value={input.section}
                        />
                      </th>
                      {standard &&
                      (standard.value == "XI") | (standard.value == "XII") ? (
                        <th>
                          {" "}
                          <select
                            name="group"
                            className="textipbill"
                            style={{
                              width: "150px",
                              border: "0.5px solid gray",
                              borderRadius: "7px",
                              height: "32px",
                            }}
                            onChange={(event) => handleFormChange(index, event)}
                            value={input.group}
                          >
                            <option value="">Select group</option>
                            {groupoptions.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </th>
                      ) : null}
                      <th>
                        {" "}
                        <Input
                          name="max_students"
                          className="textipbill"
                          style={{ width: "150px", border: "0.5px solid gray" }}
                          placeholder="Maximum Students"
                          onChange={(event) => handleFormChange(index, event)}
                          value={input.max_students}
                        />{" "}
                      </th>

                      <th>
                        {" "}
                        <Input
                          name="description"
                          className="textipbill"
                          style={{ width: "150px", border: "0.5px solid gray" }}
                          placeholder="Description"
                          onChange={(event) => handleFormChange(index, event)}
                          value={input.description}
                        />{" "}
                      </th>

                      <td>
                        {" "}
                        <Button
                          size="sm"
                          variant="outline-danger"
                          onClick={() => removeFields(index)}
                        >
                          <i className="fa fa-times" aria-hidden="true"></i>
                        </Button>
                      </td>
                    </tr>
                  </>
                );
              })}
          </table>
          <br />
        </Modal>
      </div>
    </Maincomponent>
  );
}
